export const solutionBenefits = [
  {
    title: "Lire ensemble",
    text: "Partagez des histoires courtes et illustrées que les enfants prennent plaisir à découvrir.",
    tone: "royal",
  },
  {
    title: "Échanger avec le cœur",
    text: "Parlez simplement de l’amour, du pardon, du courage et de la gratitude.",
    tone: "rosy",
  },
  {
    title: "Faire vivre la foi",
    text: "Prolongez la lecture avec des activités et de petites expériences à partager au quotidien.",
    tone: "leaf",
  },
];

export const parableElements = [
  { label: "Histoire", text: "Une histoire illustrée", icon: "book" },
  { label: "Verset", text: "Un verset biblique", icon: "cross" },
  { label: "Leçon du jour", text: "Une leçon du jour", icon: "heart" },
];

// x = position horizontale de la page sur la planche de pages réelles.
export const parablePages = [
  { title: "Le sac à dos trop lourd", x: 11 },
  { title: "La feuille qui est tombée", x: 273 },
  { title: "Le cerf-volant qui voulait voler seul", x: 534 },
  { title: "Le petit kangourou qui avait peur de sortir", x: 796 },
  { title: "L’oreille qui n’aimait pas écouter", x: 1057 },
  { title: "Le petit lapin qui ne savait pas partager", x: 1318 },
  { title: "Le phare qui avait peur de la nuit", x: 1580 },
];

export const upcomingParablePages = [
  { title: "Le petit éléphant rancunier", src: "" },
  { title: "Le petit cygne qui se comparait trop", src: "" },
];

export const heroFanPages = [534, 1318, 1580];

export const activityPages = [
  { title: "Page du cahier d’activités", src: "" },
  { title: "Page du cahier d’activités", src: "" },
  { title: "Page du cahier d’activités", src: "" },
];

export const bonuses = [
  {
    label: "Bonus 1",
    title: "30 Jours avec Jésus en Famille",
    text: "Un parcours simple pour prendre chaque jour un petit moment afin de lire, réfléchir et prier ensemble.",
    cover: "",
  },
  {
    label: "Bonus 2",
    title: "Cartes de Conversation : Parlons de Dieu Ensemble",
    text: "Des questions à partager pour parler de Dieu, des émotions et des valeurs chrétiennes avec vos enfants.",
    cover: "",
  },
  {
    label: "Bonus 3",
    title: "Mes Petites Prières du Cœur",
    text: "Des supports simples et tendres pour aider les enfants à exprimer à Dieu leurs joies, leurs peurs et leur gratitude.",
    cover: "",
  },
  {
    label: "Bonus 4",
    title: "30 Petits Gestes pour Vivre la Parole",
    text: "De petites actions à réaliser en famille pour mettre l’amour, le pardon, la générosité et la gratitude en pratique.",
    cover: "",
  },
];

export const usageSteps = [
  {
    title: "Choisissez une parabole",
    text: "Découvrez une histoire qui correspond à un thème ou à une situation du quotidien.",
  },
  {
    title: "Lisez et échangez ensemble",
    text: "Prenez un moment pour parler de l’histoire, du verset et de sa leçon.",
  },
  {
    title: "Prolongez ce moment",
    text: "Utilisez une activité, une question ou une petite prière pour faire vivre l’enseignement.",
  },
];

export const personas = [
  {
    text: "Vous souhaitez transmettre votre foi à vos enfants avec douceur et simplicité.",
    tone: "royal",
  },
  {
    text: "Vous aimeriez trouver les bons mots pour parler de Dieu et des valeurs chrétiennes.",
    tone: "sun",
  },
  {
    text: "Vous cherchez des ressources illustrées, faciles à utiliser et adaptées aux moments en famille.",
    tone: "leaf",
  },
  {
    text: "Vous voulez créer de beaux souvenirs autour de la lecture et de la foi.",
    tone: "rosy",
  },
];

export const offerItems = [
  "Plus de 50 paraboles chrétiennes illustrées",
  "Le Grand Cahier d’Activités Bibliques",
  "30 Jours avec Jésus en Famille",
  "Cartes de Conversation : Parlons de Dieu Ensemble",
  "Mes Petites Prières du Cœur",
  "30 Petits Gestes pour Vivre la Parole",
];

export const faqs = [
  {
    q: "S’agit-il d’un livre imprimé ?",
    a: "Non. Il s’agit d’un produit numérique comprenant des fichiers PDF à télécharger et à imprimer chez vous. Aucun produit physique n’est expédié.",
  },
  {
    q: "Faut-il être spécialiste de la Bible pour utiliser ce Méga Pack ?",
    a: "Pas du tout ! Les paraboles et les ressources sont conçues pour accompagner les échanges en famille de façon simple et accessible.",
  },
  {
    q: "Que contient chaque parabole ?",
    a: "Chaque parabole propose une histoire illustrée, un verset biblique et une leçon du jour.",
  },
  {
    q: "S’agit-il des paraboles racontées par Jésus ?",
    a: "Ce sont des paraboles chrétiennes illustrées originales, inspirées des enseignements et des valeurs de la Bible. Elles ne reprennent pas exclusivement les paraboles racontées par Jésus dans les Évangiles.",
  },
  {
    q: "Puis-je utiliser les activités à la maison ?",
    a: "Oui. Les ressources sont prévues pour être téléchargées et imprimées afin de les utiliser en famille.",
  },
  {
    q: "Comment recevrai-je le Méga Pack ?",
    a: "Après votre achat, vous recevrez les instructions pour accéder aux fichiers numériques.",
  },
  {
    q: "Y a-t-il une garantie ?",
    a: "Oui, le Méga Pack bénéficie d’une garantie de 7 jours, selon les conditions indiquées lors de l’achat.",
  },
];
